<div class="container-scroll-list" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()" [alwaysCallback]="true">
  <div *ngFor="let guide of guides; let i = index;">
    <app-item-cargo-from-guides [guide]="guide" class="guide-item" [ngClass]="{ 'guide-selected': guide.checked }" (click)="onSelectGuide(guide)">
    </app-item-cargo-from-guides>
  </div>
</div>
